/**
 * @generated SignedSource<<9a11a3dc633c89e1d2ba97c13033ef0b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductComponentQuery$variables = {
  ean: string;
  id: string;
  isEan?: boolean | null;
};
export type ProductComponentQuery$data = {
  readonly currentStore: {
    readonly productByEAN?: {
      readonly " $fragmentSpreads": FragmentRefs<"ProductComponent_StoreProduct">;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"ProductComponent_Store">;
  };
  readonly storeProduct?: {
    readonly " $fragmentSpreads": FragmentRefs<"ProductComponent_StoreProduct">;
  } | null;
};
export type ProductComponentQuery = {
  response: ProductComponentQuery$data;
  variables: ProductComponentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ean"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "isEan"
},
v3 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v4 = [
  {
    "args": null,
    "kind": "FragmentSpread",
    "name": "ProductComponent_StoreProduct"
  }
],
v5 = [
  {
    "kind": "Variable",
    "name": "ean",
    "variableName": "ean"
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = [
  (v6/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "imageUrl",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "description",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "partNumber",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "numberOfPendingTodos",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "hasExpiredExpireDates",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "hasPendingExpireDateActions",
    "storageKey": null
  },
  {
    "kind": "TypeDiscriminator",
    "abstractKey": "__isProductDetails"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ProductComponentQuery",
    "selections": [
      {
        "condition": "isEan",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "StoreProduct",
            "kind": "LinkedField",
            "name": "storeProduct",
            "plural": false,
            "selections": (v4/*: any*/),
            "storageKey": null
          }
        ]
      },
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": null,
          "concreteType": "Store",
          "kind": "LinkedField",
          "name": "currentStore",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "ProductComponent_Store"
            },
            {
              "condition": "isEan",
              "kind": "Condition",
              "passingValue": true,
              "selections": [
                {
                  "alias": null,
                  "args": (v5/*: any*/),
                  "concreteType": "StoreProduct",
                  "kind": "LinkedField",
                  "name": "productByEAN",
                  "plural": false,
                  "selections": (v4/*: any*/),
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        "action": "THROW"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "ProductComponentQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "currentStore",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "includeDefault",
                "value": true
              }
            ],
            "concreteType": "TodoCategory",
            "kind": "LinkedField",
            "name": "todoCategories",
            "plural": true,
            "selections": [
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "title",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "icon",
                "storageKey": null
              }
            ],
            "storageKey": "todoCategories(includeDefault:true)"
          },
          (v6/*: any*/),
          {
            "condition": "isEan",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": (v5/*: any*/),
                "concreteType": "StoreProduct",
                "kind": "LinkedField",
                "name": "productByEAN",
                "plural": false,
                "selections": (v7/*: any*/),
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      },
      {
        "condition": "isEan",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "StoreProduct",
            "kind": "LinkedField",
            "name": "storeProduct",
            "plural": false,
            "selections": (v7/*: any*/),
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "820a386b715820ee206833f3df97ced5",
    "id": null,
    "metadata": {},
    "name": "ProductComponentQuery",
    "operationKind": "query",
    "text": "query ProductComponentQuery(\n  $id: ID!\n  $ean: String!\n  $isEan: Boolean = false\n) {\n  storeProduct(id: $id) @skip(if: $isEan) {\n    ...ProductComponent_StoreProduct\n    id\n  }\n  currentStore {\n    ...ProductComponent_Store\n    productByEAN(ean: $ean) @include(if: $isEan) {\n      ...ProductComponent_StoreProduct\n      id\n    }\n    id\n  }\n}\n\nfragment ProductComponent_Store on Store {\n  ...ProductLinkedTodosFloatingAddButton_Store\n}\n\nfragment ProductComponent_StoreProduct on StoreProduct {\n  id\n  name\n  imageUrl\n  description\n  partNumber\n  ...ProductHeader_ProductDetails\n  numberOfPendingTodos\n  hasExpiredExpireDates\n  hasPendingExpireDateActions\n}\n\nfragment ProductHeader_ProductDetails on ProductDetails {\n  __isProductDetails: __typename\n  imageUrl\n  partNumber\n  name\n}\n\nfragment ProductLinkedTodosFloatingAddButton_Store on Store {\n  todoCategories(includeDefault: true) {\n    id\n    title\n    icon\n  }\n}\n"
  }
};
})();

(node as any).hash = "2ceeba3ae0b671e6387446816089e0f8";

export default node;
